import { NgModule } from '@angular/core';
import { HelpCenterRoutingModule } from './help-center-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import * as fromComponents from './components';
import { CommonModule } from '@angular/common';
import { HelpCenterComponent } from '@app/help-center/help-center.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { ResourcesComponent } from './components/resources/resources.component';
import { ProgramsComponent } from './components/programs/programs.component';
import { Tab4Component } from './components/tab4/tab4.component';
import { Tab5Component } from './components/tab5/tab5.component';
import { Tab6Component } from './components/tab6/tab6.component';

/**
 * HelpCenterModule
 */
@NgModule({
  imports: [SharedModule, HelpCenterRoutingModule, CommonModule],
  declarations: [
    HelpCenterComponent,
    ...fromComponents.components,
    NewsletterComponent,
    ResourcesComponent,
    ProgramsComponent,
    Tab4Component,
    Tab5Component,
    Tab6Component,
  ],
  providers: [],
  exports: [HelpCenterComponent, ...fromComponents.components],
})
export class HelpCenterModule {}
